/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import Button from "../../extras/Button";
import Table from "../../extras/Table";
import Pagination from "../../extras/Pagination";
import ToggleSwitch from "../../extras/ToggleSwitch";
import { closeDialog, openDialog } from "../../../redux/slice/dialogueSlice";
import Title from "../../extras/Title";
import { allUsers, blockUser } from "../../../redux/slice/userSlice";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Searching from "../../extras/Searching";
import male from "../../../assets/images/male.png";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import NotificationDialog from "./NotificationDialog";
import { permissionError } from "../../../util/Alert";
import { ReactComponent as Delievered } from "../../../assets/icon/deliever.svg";
import { IconBell, IconClockCheck, IconInfoCircle, IconShoppingBag } from "@tabler/icons-react";
import LazyImage from "../../extras/ImageFallback";
// import { ReactComponent as OrderHistory } from "../../../assets/images/order-history-icon.svg"

export const User = () => {
  const dispatch = useDispatch();
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const hasPermission = useSelector((state) => state.auth.admin.flag);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const { user, total } = useSelector((state) => state?.user);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("ALL");
  const navigate = useNavigate();

  useEffect(() => {
    const payload = {
      start: page,
      limit: rowsPerPage,
      search,
    };
    dispatch(allUsers(payload));
  }, [dispatch, page, rowsPerPage, search]);

  useEffect(() => {
    setData(user);
  }, [user]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", male);
    });
  });

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  function openImage(imageUrl) {
    // Open the image in a new tab or window
    window.open(imageUrl, "_blank");
  }

  const userTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "Image",
      Cell: ({ row }) => (
        <div className="userProfile">
          <LazyImage
            src={row?.image}
            alt=""
            style={{
              height: "50px",
              width: "50px",
              overflow: "hidden",
            }}
            onError={(e) => {
              e.target.src = male;
            }}
            className="cursor-pointer"
            onClick={() => handleInfo(row._id)}
          />
        </div>
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => (
        <span
          className="text-capitalize cursor"
          onClick={() => handleInfo(row._id)}
        >
          {row?.fname ? row?.fname + " " + row?.lname : "Salon User"}
        </span>
      ),
    },
    {
      Header: "Unique ID",
      Cell: ({ row }) => <span>{row?.uniqueId}</span>,
    },
    {
      Header: "Mobile No",
      Cell: ({ row }) => <span>{row?.mobile ? row?.mobile : "-"}</span>,
    },
    {
      Header: "Email",
      Cell: ({ row }) => (
        <span>{row?.email ? row?.email : "demo@demo.com"}</span>
      ),
    },
    {
      Header: "gender",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.gender ? row?.gender : "Not Specified"}
        </span>
      ),
    },
    {
      Header: "Block",
      Cell: ({ row }) => (
        <ToggleSwitch
          value={row?.isBlock}
          onClick={() => {
            handleStatus(row?._id);
          }}
        />
      ),
    },
    {
      Header: "Booking",
      Cell: ({ row }) => (
        <div className="action-button">
        <button
          className="btn btn-sm"
          onClick={() => handleOpenBookings(row)}
        >
           <IconClockCheck className="text-secondary" />
        </button>
        </div>
      ),
    },
    {
      Header: "Order",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
           className="btn btn-sm"
            onClick={() => handleOrderHistory(row._id)}
          >
           <IconShoppingBag className="text-secondary" />
          </button>
        </div>
      ),
    },
     {
      Header: "Notification",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => handleNotify(row._id)}
          >
             <IconBell className="text-secondary" />
          </button>
        </div>
      ),
    },
    {
      Header: "Info",
      Cell: ({ row }) => (
         <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => handleInfo(row._id)}
          >
             <IconInfoCircle className="text-secondary" />
          </button>
        </div>
      ),
    },
   
  ];

  const handleInfo = (id) => {
    if (id === "661e10c50b179996cb0690cd") return permissionError();
    navigate("/admin/user/userProfile", {
      state: {
        id,
      },
    });
  };
  const handleOrderHistory = (id) => {
    if (id === "661e10c50b179996cb0690cd") return permissionError();
    navigate("/admin/user/orderHistory", {
      state: {
        id,
      },
    });
  };

  const handleProfile = (row, type) => {
    dispatch(openDialog({ type: type, data: row }));
    sessionStorage.setItem(
      "dialog",
      JSON.stringify({ dialogue: true, type: type, data: row })
    );
  };
  const handleNotify = (id) => {
    if (id === "661e10c50b179996cb0690cd") return permissionError();
    dispatch(openDialog({ type: "notification", data: { id, type: "user" } }));
  };

  const handleStatus = (id) => {
    if (id === "661e10c50b179996cb0690cd") return permissionError();
    if (!hasPermission) return permissionError();
    dispatch(blockUser(id));
  };

  const handleDownloadPDF = () => {
    const flattenedData = data.map((user, index) => ({
      No: index + 1,
      Name: user?.fname + " " + user?.lname,
      UniqueId: user?.uniqueId,
      MobileNo: user?.mobile,
      Email: user?.email,
    }));

    const headers = ["No", "Name", "UniqueId", "MobileNo", "Email"];
    const doc = new jsPDF({
      orientation: "landscape",
    });
    doc.text("User Data", 10, 10);
    doc.autoTable({
      head: [headers],
      body: flattenedData?.map((user) => Object?.values(user)),
    });
    doc.save("user_data.pdf");
  };

  const handleDownloadCSV = () => {
    const flattenedData = data.map((user, index) => ({
      No: index + 1,
      Name: user?.fname + " " + user?.lname,
      UniqueId: user?.uniqueId,
      MobileNo: user?.mobile,
      Email: user?.email,
    }));

    const headers = ["No", "Name", "UniqueId", "MobileNo", "Email"];
    const csvContent = Papa.unparse({
      fields: headers,
      data: flattenedData,
    });
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL?.createObjectURL(blob);
    const link = document?.createElement("a");
    link.href = url;
    link.setAttribute("download", "user_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadExcel = () => {
    const flattenedData = data?.map((user, index) => ({
      No: index + 1,
      Name: user?.fname + " " + user?.lname,
      UniqueId: user?.uniqueId,
      MobileNo: user?.mobile,
      Email: user?.email,
    }));

    const headers = ["No", "Name", "UniqueId", "MobileNo", "Email"];
    const ws = XLSX.utils.json_to_sheet([headers, ...flattenedData]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "User Data");
    XLSX.writeFile(wb, "user_data.xlsx");
  };

  const handlePrint = () => {
    const flattenedData = data?.map((user, index) => ({
      No: index + 1,
      Name: user?.fname + " " + user?.lname,
      UniqueId: user?.uniqueId,
      MobileNo: user?.mobile,
      Email: user?.email,
    }));

    const headers = ["No", "Name", "UniqueId", "MobileNo", "Email"];
    const doc = new jsPDF({
      orientation: "landscape",
    });
    doc.text("User Data", 10, 10);
    doc.autoTable({
      head: [headers],
      body: flattenedData.map((user) => Object.values(user)),
    });
    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");
  };

  const handleOpenBookings = (row) => {
    if (row?._id === "661e10c50b179996cb0690cd") return permissionError();
    navigate("/admin/user/bookings", { state: { data: row } });
  };

  return (
    <>
      {dialogue && dialogueType === "notification" && (
        <div className="userTable">
          <NotificationDialog />
        </div>
      )}
      <div className="userPage">
        <div
          className="userTable user-table mb-3"
          style={{
            display: `${dialogueType === "userHistory" ? "none" : "block"}`,
          }}
        >
          {/* <Title name="Customer" />
           */}
          <div className="user-table-top">
            <div className=" d-flex justify-content-between align-items-center w-100 ">
              <div className="w-100">
                <h5 className="main-title">Customer</h5>
              </div>
              <div className="d-flex gap-2 justify-content-end w-100">
                <Searching
                  type={`server`}
                  data={user}
                  setData={setData}
                  column={userTable}
                  serverSearching={handleFilterData}
                />
                <div>
                  <>
  <button
    type="button"
    className="themeBtn dropdown-toggle"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    Donwload
  </button>
  <ul className="dropdown-menu">
    <li>
      <div className="dropdown-item" onClick={handleDownloadPDF}>
        PDF
      </div>
    </li>
    <li>
      <div className="dropdown-item" onClick={handleDownloadCSV}>
        CSV
      </div>
    </li>
    <li>
      <div className="dropdown-item" onClick={handleDownloadExcel}>
        Excel
      </div>
    </li>
    <li>
      <div className="dropdown-item" onClick={handlePrint}>
        Print
      </div>
    </li>
  </ul>
</>

                </div>
              </div>
            </div>
          </div>
          {/* <div className="betBox">
            <div className="d-flex justify-content-start  gap-2">
              <Button
                className="bg-secondary text-white p5-y"
                onClick={handleDownloadPDF}
                text={`PDF`}
              />
              <Button
                className="bg-info text-white p5-y"
                onClick={handleDownloadCSV}
                text={`CSV`}
              />
              <Button
                className="bg-primary text-white p5-y"
                onClick={handleDownloadExcel}
                text={`Excel`}
              />
              <Button
                className="bg-danger text-white p5-y"
                onClick={handlePrint}
                text={`Print`}
              />
            </div>
            <div className="col-md-8 col-lg-5  ms-auto"></div>
          </div> */}
          <div>
            <Table
              data={data}
              mapData={userTable}
              serverPerPage={rowsPerPage}
              Page={page}
            />
            <Pagination
              type={"server"}
              serverPage={page}
              setServerPage={setPage}
              serverPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              totalData={total}
            />
          </div>
        </div>
      </div>
    </>
  );
};
